module.exports = __webpack_public_path__ + "img/fullscreen_white.6479faf2.svg";